import {
  fetchQuestionNote,
  updateQuestionNote,
  fetchBulletNote,
  updateBulletNote,
} from '@/global/service';

import * as constants from './Note.constants';

const state = {
  isNoteFetched: false,
  isNoteSaving: false,
  isNoteSaved: false,

  dateNoteSaved: '',

  isSaveImmediately: false,

  noteContent: '',
};

const mutations = {
  [constants.SET_IS_NOTE_FETCHED](state, isNoteFetched) {
    state.isNoteFetched = isNoteFetched;
  },

  [constants.SET_IS_NOTE_SAVING](state, isNoteSaving) {
    state.isNoteSaving = isNoteSaving;
  },

  [constants.SET_IS_NOTE_SAVED](state, isNoteSaved) {
    state.isNoteSaved = isNoteSaved;
  },

  [constants.SET_DATE_NOTE_SAVED](state, dateNoteSaved) {
    state.dateNoteSaved = dateNoteSaved;
  },

  [constants.SET_IS_SAVE_IMMEDIATELY](state, isSaveImmediately) {
    state.isSaveImmediately = isSaveImmediately;
  },

  [constants.FETCH_NOTE_SUCCESS](state, noteContent) {
    state.noteContent = noteContent;
  },

  [constants.DUMMY_MUTATION]() {
    //
  },
};

const actions = {
  async fetchQuestionNote({ commit }, payload) {
    const res = await fetchQuestionNote(payload);
    commit(constants.FETCH_NOTE_SUCCESS, res.data.data.content);
  },

  async updateQuestionNote({ commit }, payload) {
    await updateQuestionNote(payload);
    commit(constants.DUMMY_MUTATION);
  },

  async fetchBulletNote({ commit }, payload) {
    const res = await fetchBulletNote(payload);
    commit(constants.FETCH_NOTE_SUCCESS, res.data.content);
  },

  async updateBulletNote({ commit }, payload) {
    await updateBulletNote(payload);
    commit(constants.DUMMY_MUTATION);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
